__turbopack_context__.v({
  "back": "flip-card-module-scss-module__4IA7eq__back",
  "bottomRow": "flip-card-module-scss-module__4IA7eq__bottomRow",
  "cardContainer": "flip-card-module-scss-module__4IA7eq__cardContainer",
  "cardTitle": "flip-card-module-scss-module__4IA7eq__cardTitle",
  "cardTitleFront": "flip-card-module-scss-module__4IA7eq__cardTitleFront",
  "closeIcon": "flip-card-module-scss-module__4IA7eq__closeIcon",
  "description": "flip-card-module-scss-module__4IA7eq__description",
  "descriptionContainer": "flip-card-module-scss-module__4IA7eq__descriptionContainer",
  "divider": "flip-card-module-scss-module__4IA7eq__divider",
  "dividerContainer": "flip-card-module-scss-module__4IA7eq__dividerContainer",
  "dividerFront": "flip-card-module-scss-module__4IA7eq__dividerFront",
  "dot": "flip-card-module-scss-module__4IA7eq__dot",
  "featureCard": "flip-card-module-scss-module__4IA7eq__featureCard",
  "filler": "flip-card-module-scss-module__4IA7eq__filler",
  "flipButton": "flip-card-module-scss-module__4IA7eq__flipButton",
  "front": "flip-card-module-scss-module__4IA7eq__front",
  "numberText": "flip-card-module-scss-module__4IA7eq__numberText",
  "numberTextFront": "flip-card-module-scss-module__4IA7eq__numberTextFront",
  "plusIcon": "flip-card-module-scss-module__4IA7eq__plusIcon",
  "side": "flip-card-module-scss-module__4IA7eq__side",
  "sideContainer": "flip-card-module-scss-module__4IA7eq__sideContainer",
  "status": "flip-card-module-scss-module__4IA7eq__status",
  "titleText": "flip-card-module-scss-module__4IA7eq__titleText",
  "titleTextFront": "flip-card-module-scss-module__4IA7eq__titleTextFront",
  "topRow": "flip-card-module-scss-module__4IA7eq__topRow",
});
